import { useState } from "react";
import StudentCard from "./StudentCard";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MYPAGE_MENU_LIST, MYPAGE_HTML_TITLE } from "../../../utils/config";
import ScreenColorSetting, {
  getDefaultScreenColor,
} from "./ScreenColorSetting";

const Layout = () => {
  // 画面背景色 color-standard or color-black or color-blue
  const [screenColor, setScreenColor] = useState(getDefaultScreenColor());
  // 学生証の表示有無
  const [isStudentIDVisible, setIsStudentIDVisible] = useState(false);

  const location = useLocation();
  const pathname = useLocation().pathname;

  const d = new Date();
  const date =
    d.getFullYear() +
    "年" +
    (d.getMonth() + 1) +
    "月" +
    d.getDate() +
    "日 " +
    d.getHours() +
    "時" +
    ("00" + d.getMinutes()).slice(-2) +
    "分";

  useEffect(() => {
    // スクロールを一番上に移動
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    // HTML Titleの設定
    const current_menu = MYPAGE_MENU_LIST.filter((menu) =>
      location.pathname.includes(menu.url)
    );
    if (current_menu.length > 0) {
      document.title = `${current_menu[0]?.title} | ${MYPAGE_HTML_TITLE}`;
    }
  }, [location]);

  return (
    <>
      <ScreenColorSetting screenColor={screenColor} />
      <div className="mypage-site">
        <div className="mypage">
          <StudentCard
            isVisible={isStudentIDVisible}
            setIsStudentIDVisible={setIsStudentIDVisible}
            date={date}
          />
          <Header
            setScreenColor={setScreenColor}
            screenColor={screenColor}
            setIsStudentIDVisible={setIsStudentIDVisible}
          />
          <main
            className={
              pathname === "/mypage/top" || pathname === "/mypage/apierror"
                ? "l-main"
                : "l-page"
            }
          >
            <Outlet />
            <Sidebar />
          </main>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Layout;
